import styles from './IntroductionMedia.module.css';

type IntroductionMediaProps = {
  mediaSrc: string;
};

export const IntroductionMedia = ({ mediaSrc }: IntroductionMediaProps) => {
  return (
    <div className={styles.introductionMediaSection}>
      <img className={styles.introductionMedia} src={mediaSrc} alt='' />
    </div>
  );
};
